module.exports = __webpack_public_path__ + "img/Logo_Header2.773d368a.svg";